import { Dispatch, SetStateAction } from 'react';
import { SubmitMaterialItemType } from '../../types';
import styled from '@emotion/styled';
import { gray, primary } from '@styles/Colors';
import Typography from '@components/_atoms/Typography';
import { IconSize, TypoVariant } from '@constants/atoms';
import Icon from '@components/_atoms/Icon';

type Props = {
  idx: number;
  data: SubmitMaterialItemType;
  itemIds: number[];
  setItemIds: Dispatch<SetStateAction<number[]>>;
};

const Layout = styled.div`
  padding: 16px 10px;
  border-bottom: 1px solid ${gray.gray3};

  display: grid;
  column-gap: 24px;
  &:last-child {
    border-bottom: none;
  }
`;

export default function MaterialRow({ idx, data, itemIds, setItemIds }: Props) {
  const gridTemplateColumns = '48px 1fr 80px 120px 120px 24px';

  const { item_id, quantityString, unitPriceString, totalPriceString, itemDescription } = data;

  const isCheck = itemIds.includes(item_id!);
  const fontColor = isCheck ? primary.gray : gray.gray4;

  const handleCheckItem = () => {
    // 기존에 id가 있다면 제거, 없다면 추가
    const ids = isCheck ? itemIds.filter((id) => id !== item_id) : [...itemIds, item_id];
    setItemIds(ids);
  };

  return (
    <Layout style={{ gridTemplateColumns }}>
      <Typography variant={TypoVariant.B3} color={fontColor}>
        {idx + 1}
      </Typography>
      <Typography variant={TypoVariant.B3} color={fontColor}>
        {itemDescription}
      </Typography>
      <Typography variant={TypoVariant.B3} color={fontColor}>
        {quantityString}
      </Typography>
      <Typography variant={TypoVariant.B3} color={fontColor}>
        {unitPriceString}
      </Typography>
      <Typography variant={TypoVariant.B3} color={fontColor}>
        {totalPriceString}
      </Typography>
      {isCheck ? (
        <Icon name="close" fill="transparent" stroke={primary.gray} size={IconSize.SMALL} onClick={handleCheckItem} />
      ) : (
        <Icon name="reset" fill="transparent" stroke={gray.gray4} size={IconSize.SMALL} onClick={handleCheckItem} />
      )}
    </Layout>
  );
}
